import './App.css';
import React,{useState} from 'react';

function App() {
  const [count, setCount] = useState(20);
  return (
    <div className="App">
      <h1>Counter App</h1>
      <h2>Counter is {count}</h2>
      <button id='btn1' onClick={() => setCount(count + 1)}>+</button>
      <button id='btn2' onClick={() => setCount(count - 1)}>-</button>
    </div>
  );
}

export default App;
